import ReactDOM from "react-dom/client";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { BrowserRouter } from "react-router-dom";

import { createTheme, ThemeProvider } from "@mui/material/styles";
import { ptBR } from "@mui/material/locale";
import { ptBR as dPtBr } from "@mui/x-data-grid/locales";

// Bust stubborn caches once per session to force fresh bundle and data loads
if (!sessionStorage.getItem("r")) {
  sessionStorage.setItem("r", "1");
  const url = new URL(window.location.href);
  const timestamp = Date.now().toString();
  url.searchParams.set("v", timestamp);
  console.log(`[Cache Bust] Reloading with v=${timestamp}`);
  window.location.replace(url.toString());
} else {
  console.log("[Cache Bust] Already loaded this session");
}


const root = ReactDOM.createRoot(document.getElementById("root"));

const theme = createTheme(
  {
    palette: {
      mode: "light",
      primary: {
        main: "#57C4C2",
      },
      secondary: {
        main: "#000000",
      },
      error: {
        main: "#DE6061",
      },
      // whatever
      success: {
        main: "#57C4C2",
      },
      warning: {
        main: "#57C4C2",
      },
    },
  },
  ptBR,
  dPtBr
);

root.render(
  <BrowserRouter
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
    }}
  >
    <ThemeProvider theme={theme}>
      <App />
    </ThemeProvider>
  </BrowserRouter>
);

reportWebVitals();
